import { render, staticRenderFns } from "./noHandleList.vue?vue&type=template&id=59408157&scoped=true&"
import script from "./noHandleList.vue?vue&type=script&lang=js&"
export * from "./noHandleList.vue?vue&type=script&lang=js&"
import style0 from "./noHandleList.vue?vue&type=style&index=0&id=59408157&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59408157",
  null
  
)

export default component.exports